<div ngbDropdown class="dropdown" placement="bottom-end" class="user-menu">
  <button type="button" class="btn btn-link nav-link d-flex align-items-center" id="user-dropdown" ngbDropdownToggle>
    <span *ngIf="user && user.email ">{{ user.email }}</span>
  </button>
  <div ngbDropdownMenu aria-labelledby="user-dropdown" class="dropdown-menu dropdown-menu-end">
    <h6 class="dropdown-header bg-primary text-white">
      {{ user?.email }}
    </h6>
    <button type="button" class="dropdown-item" (click)="logout()" (keyup.enter)="logout()">
      Sign out
    </button>
  </div>
</div>